import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeftSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronLeftSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M8.93945 11.9999L14.0001 6.93923L15.0608 7.99989L11.0608 11.9999L15.0608 15.9999L14.0001 17.0605L8.93945 11.9999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeftSmall;
